import React from 'react';

export const IconClock = ({
  size = 10,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.67501 7.12501L7.31251 6.48751L5.45001 4.62501V2.00001H4.55001V5.00001L6.67501 7.12501ZM5.00001 9.80001C4.33854 9.80001 3.71693 9.67501 3.13516 9.42501C2.5534 9.17501 2.04376 8.83126 1.60626 8.39376C1.16876 7.95626 0.825012 7.44602 0.575012 6.86304C0.325012 6.28004 0.200012 5.65713 0.200012 4.99429C0.200012 4.33144 0.325012 3.70834 0.575012 3.12501C0.825012 2.54168 1.16876 2.03334 1.60626 1.60001C2.04376 1.16668 2.554 0.825012 3.13699 0.575012C3.71998 0.325012 4.34289 0.200012 5.00574 0.200012C5.66859 0.200012 6.2917 0.326012 6.87508 0.578012C7.45848 0.830012 7.96594 1.17201 8.39748 1.60401C8.82903 2.03601 9.17068 2.54401 9.42241 3.12801C9.67414 3.71201 9.80001 4.33601 9.80001 5.00001C9.80001 5.66148 9.67501 6.28309 9.42501 6.86486C9.17501 7.44663 8.83334 7.95626 8.40001 8.39376C7.96668 8.83126 7.4578 9.17501 6.87337 9.42501C6.28895 9.67501 5.66449 9.80001 5.00001 9.80001Z"
        fill="currentColor"
      />
    </svg>
  );
};
